// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2nXOj","log":"ModalInventoryLogs_log__39DOV","date":"ModalInventoryLogs_date__3kQMs","userName":"ModalInventoryLogs_userName__2Awz_"};